import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  expRoot: {
    boxShadow: "none",
    borderBottom: "1px solid #eeeeee",
    [theme.breakpoints.down("xs")]: {
      "&.indexAccordion, &.conditionsAccordion": {
        marginTop: 8,
        border: "none",
        boxShadow: "0px 1px 7px 0px #0000001a",
        "&.Mui-expanded": {
          marginTop: 8,
          "&:first-child": {
            marginTop: 8
          }
        }
      }
    }
  },
  expDisabled: {
    [theme.breakpoints.down("xs")]: {
      marginTop: 8
    }
  },
  accordionSummary: {
    "& .MuiIconButton-root": {
      color: "#595a5a"
    }
  },
  sumRoot: {
    padding: "0px 20px",
    "&.Mui-expanded": {
      borderBottom: "none"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0px 12px"
    }
  },
  sumRootExpanded: {
    marginBottom: "0 !important"
  },
  summaryContent: {
    display: "flex",
    alignItems: "center",
    width: "100%"
  },
  summaryTitle: {
    display: "flex",
    alignItems: "center",
    fontSize: 16,
    width: "100%"
  },
  accordionDetails: {
    display: "flex",
    flexDirection: "column",
    padding: "4px 20px",
    [theme.breakpoints.down("xs")]: {
      padding: "6px 12px"
    }
  },
  myMatches: {
    fontSize: 14,
    fontWeight: 600,
    marginRight: 8
  },
  matchesHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: 14
  },
  lastRaceIconDetails: {
    width: 32,
    height: 16,
    color: "#48769b",
    position: "relative",
    bottom: 1
  },
  customIconDetails: {
    width: 32,
    height: 21,
    color: "#998765"
  },
  matchesHeaderText: {
    fontWeight: 600,
    color: "#333d40",
    marginLeft: 10
  },
  matchesText: {
    fontWeight: 600,
    color: "#333d40"
  },
  matchesList: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: 16,
    gap: 10
  },
  matchesItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: 276,
    height: 37,
    padding: "2px 13px",
    borderRadius: "3px",
    border: " 1px solid #998765",
    backgroundColor: "rgba(240, 227, 191, 1)",
    boxSizing: "border-box",
    cursor: "pointer"
  },
  lastRaceMatch: {
    border: "1px solid #48769b",
    backgroundColor: "#81daf9"
  },
  horseDetailsLinkIcon: {
    height: 16,
    color: " #48769b",
    position: "relative",
    left: 5
  },
  customMatches: {
    color: "#998765"
  }
}));
